import {ChangeDetectorRef, Component, ElementRef, Input, OnInit} from '@angular/core';
import {EngineeringColumn} from '../../../../data/engineering/engineering-column';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {ActivityEngineeringService} from '../../../../data/activity-engineering.service';
import {EngineeringTileComponent} from './engineering-tile/engineering-tile.component';

@Component({
  selector: 'app-engineering-column',
  templateUrl: './engineering-column.component.html',
  styleUrls: ['./engineering-column.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EngineeringColumnComponent implements OnInit {

  constructor(
      protected engineeringService: ActivityEngineeringService,
      protected changeDetectorRef: ChangeDetectorRef
  ) {
  }

  @Input()
  column: EngineeringColumn
  @Input()
  device: string

  private tilesMap = new Map<number, EngineeringTileComponent>();
  ngOnInit(): void {
  }

  tileDrop(event: CdkDragDrop<EngineeringColumn>) {
    const previousColumn = event.previousContainer.data
    const currentColumn = event.container.data
    const status = currentColumn.statusId;
    const activity = previousColumn.activities[event.previousIndex]

    this.engineeringService.sendCommand(activity.id, 'move', currentColumn.title);

    // console.log('drop', activity.id)
    // const tile = event.previousContainer.tilesMap[activity.id];
    // this.tilesMap[activity.id] = tile;
    // tile.movedToOnHold()
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data.activities, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data.activities,
        event.container.data.activities,
        event.previousIndex,
        event.currentIndex,
      );
    }

    const columnName = currentColumn.parent ? currentColumn.parent.title : currentColumn.title;
    const user = currentColumn.parent ? currentColumn.parent.user : null;
    if (user) {
      if (user.id !== activity.userId) {
        activity.assignDate = new Date()
      }
      if (columnName === 'Completed') {
        activity.toggleDate = new Date()
        activity.ready = false
      }
      activity.userId = user.id
      activity.userName = user.name
      activity.userShortCode = user.shortCode
      activity.userBgColor = user.bgColor
      this.moveActivity(activity.id, user.id, columnName, status, event.currentIndex)
    } else {
      this.moveActivity(activity.id, null, columnName, status, event.currentIndex)
      if (columnName === 'Completed') {
        activity.toggleDate = new Date()
        activity.ready = true
        currentColumn.activities.sort((a, b) => {
          if (a.toggleDate < b.toggleDate) { return 1; }
          if (a.toggleDate > b.toggleDate) { return -1; }
          return 0;
        })
      } else {
        activity.userId = null
        activity.userName = null
        activity.userShortCode = null
        activity.userBgColor = null
        activity.assignDate = null
        currentColumn.activities.sort((a, b) => {
          if (a.startDate < b.startDate) { return -1; }
          if (a.startDate > b.startDate) { return 1; }
          return 0;
        })
      }
    }
    // this.changeDetectorRef.detectChanges()
  }

  moveActivity(activityId: number, userId: number, columnName: string, statusId: number, pos: number) {
    this.engineeringService.moveActivity(activityId, userId, columnName, statusId, pos).subscribe((column: EngineeringColumn) => {
    })
  }

  registerChild(tile: EngineeringTileComponent) {
    if (tile) {
      this.tilesMap.set(tile.tile.id, tile);
    }
  }

}
